// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"21911106","87":"838eef0f","210":"061078b1","322":"7b32b4e3","369":"75530990","382":"282d2ba9","454":"2c206d88","469":"557243e1","602":"1349dcc0","766":"3fc3e670","829":"0a41b28a","854":"742512c3","919":"88cda408","924":"26b199c0","940":"5a80d4fc"}[chunkId] + ".chunk.js";
};